import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Pencil,
  Trash2,
  ArrowDownToLine,
  Settings,
  Shield,
} from "lucide-react";
import {
  GET_ALL_CLIENTS,
  GO_TO_DASHBOARDS,
  UPDATE_USER_ACTIVE_STATUS,
  DELETE_USER_SERVICES,
} from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import { useDispatch } from "react-redux";
import { fa_time, fDateTime } from "../../../../Utils/Date_formet";
import toast from "react-hot-toast";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import { GET_IP } from "../../../../Service/common.service";
import { Get_All_Service_for_Client } from "../../../../ReduxStore/Slice/Common/commoSlice";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import Loader from "../../../../Utils/Loader";
import Swal from "sweetalert2";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable1";
import {
  DawnloadData,
  updateBacktestPermission,
} from "../../../../Service/admin.service";
import { exportToCSV } from "../../../../Utils/main/ExportToCSVdata";
import { Modal, Button, Form, Badge, Alert } from "react-bootstrap";
import axios from "axios";

const AllClients = () => {
  const [ip, setIp] = useState("");

  useEffect(() => {
    GET_IP().then((response) => {
      setIp(response.data?.ip);
    });
  }, []);
  const navigate = useNavigate();

  const permission = JSON.parse(localStorage.getItem("permission"));
  const brokers = permission?.broker_id || [];

  const location = useLocation();
  var dashboard_filter = location.search.split("=")[1];
  const dispatch = useDispatch();
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const [refresh, setrefresh] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [PanelStatus, setPanelStatus] = useState("2");
  const [ClientStatus, setClientStatus] = useState("null");
  const [selectBroker, setSelectBroker] = useState("null");
  const [ForGetCSV, setForGetCSV] = useState([]);
  const [getAllClients, setAllClients] = useState({ loading: true, data: [] });
  const [getAllStrategyNameData, setAllStrategyName] = useState([]);
  const [StrategyClientStatus, setStrategyClientStatus] = useState("all");
  const [getPage, setPage] = useState(1);
  const [getSizePerPage, setSizePerPage] = useState(10);
  const [getHeaderName, setHeaderName] = useState("All Clients");
  const [searchQuery, setSearchQuery] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [downloading, setDownloading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);

  // Backtest Permission Modal States
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [permissionLoading, setPermissionLoading] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newLimit, page) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  const handleUpdatePermission = async () => {
    if (!selectedUser) return;

    setPermissionLoading(true);
    try {
      const response = await updateBacktestPermission(
        {
          userId: selectedUser._id,
          permission: selectedUser.backtestPermission,
        },
        user_details.token
      );

      if (response.status) {
        toast.success(response.msg);

        // Update the user in the local state
        setAllClients((prev) => ({
          ...prev,
          data: prev.data.map((user) =>
            user._id === selectedUser._id
              ? { ...user, backtestPermission: selectedUser.backtestPermission }
              : user
          ),
        }));

        setShowPermissionModal(false);
      } else {
        toast.error(response.msg || "Failed to update permission");
      }
    } catch (error) {
      console.error("Error updating permission:", error);
      toast.error("Failed to update permission. Please try again.");
    } finally {
      setPermissionLoading(false);
    }
  };

  useEffect(() => {
    const GetAllStrategyName = async () => {
      await dispatch(
        Get_All_Service_for_Client({
          req: {},
          token: user_details?.token,
        })
      )
        .unwrap()
        .then((response) => {
          if (response.status) {
            setAllStrategyName(response.data);
          }
        });
    };

    GetAllStrategyName();
  }, [dispatch, user_details?.token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await GetClientsApi();
      } catch (error) {
        return;
      }
    };

    fetchData();
  }, [
    StrategyClientStatus,
    getPage,
    getSizePerPage,
    ClientStatus,
    PanelStatus,
    selectBroker,
    searchQuery,
    refresh,
    limit,
    currentPage,
  ]);

  useEffect(() => {
    setPage(1);
    setSizePerPage(10);
  }, [
    StrategyClientStatus,
    ClientStatus,
    PanelStatus,
    selectBroker,
    searchQuery,
    refresh,
  ]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      handleSearch();
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  const handleSearch = () => {
    setSearchQuery(searchInput.trim());
  };

  const GetClientsApi = async () => {
    var req1 = {
      Find_Role: user_details && user_details.Role,
      user_ID: user_details && user_details.user_id,
      stgId: StrategyClientStatus,
      page: currentPage,
      limit: limit,
      ClientStatus: ClientStatus,
      PanelStatus: PanelStatus,
      selectBroker: selectBroker,
      dashboard_filter: dashboard_filter,
      searchQuery: searchQuery,
      StarUsers: 0,
    };

    await dispatch(GET_ALL_CLIENTS(req1))
      .unwrap()
      .then((response) => {
        if (response.status) {
          if (dashboard_filter !== undefined) {
            let abc;

            const filterHeaderNames = {
              "000": "",
              111: "Total Active Clients",
              110: "Total Expired Clients",
              21: "Active Live Client",
              2: "Total Live Client",
              20: "Expired Live Client",
              1: "Total Demo Client",
              11: "Active Demo Client",
              10: "Expired Demo Client",
              0: "Total 2 Days Client",
              "01": "Active 2 Days Client",
              "00": "Expired 2 Days Client",
              ADMIN: "Admin Clients",
              SUBADMIN: "Sub Admin Clients",
            };

            setHeaderName(filterHeaderNames[dashboard_filter] || "");

            abc =
              response.data &&
              response.data.filter((item) => {
                const currentDate = new Date();

                switch (dashboard_filter) {
                  case "000":
                    return (
                      item.Role === "USER" &&
                      new Date(item.EndDate) <= currentDate
                    );

                  case "ADMIN":
                  case "SUBADMIN":
                    return item.parent_role === dashboard_filter;
                  default:
                    return true;
                }
              });

            setAllClients({
              loading: false,
              data: abc,
              pagination: response?.pagination,
            });
            setTotalRows(response?.pagination?.total || 0);

            return;
          }
          setTotalRows(response?.pagination?.total || 0);

          setAllClients({
            loading: false,
            data: response.data,
            pagination: response?.pagination,
          });

          forCSVdata(response.data);
        } else {
          setAllClients({
            loading: false,
            data: response.data,
            pagination: response?.pagination,
          });
        }
      });
  };

  const Delete_user = async (id) => {
    var req1 = {
      id: id,
    };
    await dispatch(DELETE_USER_SERVICES(req1))
      .unwrap()
      .then((response) => {
        if (response.status) {
          toast.success(response.msg);

          setrefresh(!refresh);
        } else {
          toast.error(response.msg);
        }
      });
  };

  const activeUser = async (e, data) => {
    const originalStatus = e.target.checked; // save current checkbox state

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the status for this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    });

    if (result.isConfirmed) {
      const req = {
        id: data._id,
        user_active_status: originalStatus ? "1" : "0",
        network_ip: ip, // your network IP variable
      };

      try {
        const response = await dispatch(
          UPDATE_USER_ACTIVE_STATUS(req)
        ).unwrap();
        if (response.status) {
          toast.success(response.msg);
          setrefresh(!refresh); // refresh data
        } else {
          toast.error(response.msg);
          e.target.checked = !originalStatus; // revert if API fails
        }
      } catch (err) {
        toast.error("Something went wrong!");
        e.target.checked = !originalStatus; // revert if error
      }
    } else {
      // revert checkbox if user cancels
      e.target.checked = !originalStatus;
    }
  };

  const showLicenceName = (value1, licence_type) => {
    let value = parseInt(value1);

    if (licence_type === "0") {
      return "2 Days";
    } else if (licence_type === "1") {
      return "Demo";
    } else {
      return value;
    }
  };

  const handleDownload = async (row, key) => {
    setDownloading(true);
    try {
      const data = { id: row._id, key };
      const response = await DawnloadData(data);

      if (response.status) {
        const fileName = key === 1 ? "Trading_Status" : "Broker_Response";
        exportToCSV(response.data, fileName);
        toast.success(`${fileName} downloaded successfully`);
      } else {
        toast.error(response.message || "Failed to fetch download data");
      }
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Something went wrong while downloading.");
    } finally {
      setDownloading(false);
    }
  };

  const columns = [
    {
      name: "No",
      selector: (row, index) => (currentPage - 1) * limit + index + 1,
      sortable: false,
      width: "70px",
    },

    {
      name: "User Name",
      selector: (row) => row.UserName,
      cell: (row) => (
        <>
          <img
            src={
              row.profileimg ||
              "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            }
            alt="User Avatar"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
          <div>{row.UserName || "-"}</div>
        </>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Email",
      selector: (row) => row.Email,
      cell: (row) => <div>{row.Email || "-"}</div>,
      sortable: true,
      width: "220px",
    },
    {
      name: "Full Name",
      selector: (row) => row.FullName,
      cell: (row) => <div>{row.FullName || "-"}</div>,
      sortable: true,
      width: "150px",
    },

    {
      name: "Phone",
      selector: (row) => row.PhoneNo,
      cell: (row) => <div>{row.PhoneNo || "-"}</div>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Broker",
      selector: (row) => row.broker,
      cell: (row) => <div>{showBrokerName(row.broker, row.license_type)}</div>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Services",
      selector: (row) => row.licence,
      cell: (row) => (
        <div>{showLicenceName(row.licence, row.license_type)}</div>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.ActiveStatus,
      cell: (row) => (
        <label className="toggle mt-2">
          <input
            className="toggle-checkbox"
            type="checkbox"
            checked={row.ActiveStatus === "1"}
            onChange={(e) => activeUser(e, row)}
          />
          <div
            className={`toggle-switch ${row.ActiveStatus === "1" ? "bg-success" : "bg-danger"
              }`}
          ></div>
        </label>
      ),
      sortable: false,
      width: "150px",
    },
    {
      name: "Go To Dashboard",
      selector: () => null,
      cell: (row) => {
        const isInactive =
          row.AppLoginStatus === "0" && row.WebLoginStatus === "0";

        return (
          <button
            className={`btn btn-sm fw-semibold text-white px-3 py-1 rounded-pill border-0 ${isInactive ? "bg-danger disabled-btn" : "bg-success active-btn"
              }`}
            style={{
              width: "160px",
              fontSize: "0.85rem",
              cursor: isInactive ? "not-allowed" : "pointer",
              transition: "all 0.3s",
              boxShadow: isInactive
                ? "inset 0 0 0 transparent"
                : "0 0 10px rgba(86, 192, 128, 0.6)",
            }}
            onClick={() => {
              if (!isInactive) goToDashboard(row, row._id, row.Email);
            }}
            disabled={isInactive}
          >
            {isInactive ? "🚫 Inactive" : "📊 Go Dashboard"}
          </button>
        );
      },
      width: "200px",
    },
    {
      name: "Trade",
      selector: (row) => row.TradingStatus,
      cell: (row) => {
        const isInactive =
          row.TradingStatus === "0" || row.TradingStatus === null;
        const hasNoDates = !row.StartDate && !row.EndDate;

        const style = {
          color: isInactive ? "#FF0000" : "#008000",
          fontSize: hasNoDates ? "13px" : "25px",
          fontWeight: hasNoDates ? "normal" : "bold",
        };

        return hasNoDates ? (
          <span style={style}>Activate Subadmin Clients</span>
        ) : (
          <span style={style}>&#9679;</span> // dot
        );
      },
      width: "80px",
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          {" "}
          <div className="d-flex">
            <span
              title="Edit"
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate(`/admin/client/edit/${row._id}`, { state: row })
              }
            >
              <Pencil
                size={20}
                color="#198754"
                strokeWidth={2}
                className="mx-1"
              />
            </span>

            {/* <span
            title="Backtest Permission"
            style={{ cursor: "pointer" }}
            onClick={() => handleOpenPermissionModal(row)}
          >
            <Shield
              size={20}
              color={row.backtestPermission === "1" ? "#28a745" : "#dc3545"}
              strokeWidth={2}
              className="mx-1"
            />
          </span> */}
            {(row.license_type === "1" || row.license_type === 1) && (
              <span
                title="Delete"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "This client will be deleted permanently!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#6c757d",
                    confirmButtonText: "Yes, delete it!",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      Delete_user(row._id);
                      Swal.fire(
                        "Deleted!",
                        "Client has been deleted.",
                        "success"
                      );
                    }
                  });
                }}
              >
                <Trash2
                  size={20}
                  color="#d83131"
                  strokeWidth={2}
                  className="mx-1"
                />
              </span>
            )}
          </div>
          <div
            className="d-flex justify-content-center"
            style={{ width: "150px" }}
          >
            <Link
              className="btn px-3"
              onClick={() => handleDownload(row, 1)}
              title="Trading Status"
            >
              <ArrowDownToLine style={{ color: "green" }} />
            </Link>
            <Link
              className="btn px-3"
              onClick={() => handleDownload(row, 2)}
              title="Broker Response"
            >
              <ArrowDownToLine style={{ color: "blue" }} />
            </Link>
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "250px",
    },

    {
      name: "Create Date",
      selector: (row) => row.CreateDate,
      cell: (row) => <div>{fDateTime(row.CreateDate)}</div>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Start Date",
      selector: (row) => row.StartDate,
      cell: (row) => <div>{row.StartDate ? fa_time(row.StartDate) : "-"}</div>,
      sortable: true,
      width: "150px",
    },
    {
      name: "End Date",
      selector: (row) => row.EndDate,
      cell: (row) => <div>{row.EndDate ? fa_time(row.EndDate) : "-"}</div>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Client Key",
      selector: (row) => row.client_key,
      cell: (row) => <div>{row.client_key || "-"}</div>,
      sortable: true,
      width: "150px",
    },
  ];

  const showBrokerName = (value1, licence_type) => {
    if (licence_type === "1") {
      return "Demo";
    }

    let BrokerArry = [
      {
        label: "CoinDCX",
        value: "1",
      },
      {
        label: "Delta Exchange",
        value: "2",
      },
      {
        label: "Binance",
        value: "3",
      },
      {
        label: "Zabpay",
        value: "4",
      },
      {
        label: "coinswitch",
        value: "5",
      },
      {
        label: "Pi42",
        value: "6",
      },
    ];
    const foundBroker = BrokerArry?.find((item) => item?.value == value1);
    return foundBroker ? foundBroker.label : "-";
  };

  const forCSVdata = (data) => {
    let csvArr = [];
    if (data.length > 0) {
      data.map((item) => {
        return csvArr.push({
          FullName: item.FullName,
          UserName: item.UserName,
          Email: item.Email,
          PhoneNo: item.PhoneNo,
          StartDate: fa_time(item.StartDate),
          EndDate: fa_time(item.EndDate),
          "license type": showLicenceName(item.licence, item.license_type),
          broker: showBrokerName(item.broker, item.license_type),
          TradingStatus: item.TradingStatus,
        });
      });

      setForGetCSV(csvArr);
    }
  };

  const goToDashboard = async (row, asyncid, email) => {
    if (row.AppLoginStatus === "1" || row.WebLoginStatus === "1") {
      let req = {
        Email: email,
      };

      await dispatch(GO_TO_DASHBOARDS(req))
        .unwrap()
        .then((response) => {
          if (response.status) {
            localStorage.setItem("route", "/admin/allclients");
            localStorage.setItem("gotodashboard", JSON.stringify(true));
            localStorage.setItem(
              "user_details_goTo",
              JSON.stringify(response.data)
            );
            localStorage.setItem(
              "user_role_goTo",
              JSON.stringify(response.data.Role)
            );
            navigate("/client/dashboard");
          }
        });
    }
  };

  return (
    <>
      <div className="export">
        <Content
          Page_title={getHeaderName}
          Page_title_showClient="Manage and monitor all trading accounts"
          button_title="Add Client"
          route="/admin/client/add"
          show_csv_button={false}
          csv_data={ForGetCSV}
          csv_title="Client-List"
          button_status={permission?.Addclient == 1 && true}
        >
          <div className=" mb-4">
            <div className="mx-0 row filter-row">
              <div className="col-lg-3 ">
                <div className="mb-3">
                  <label className="form-label mb-1 fw-semibold">Search</label>
                  <div className="input-group">
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search..."
                      id="searchInput"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-6">
                <div className="mb-3">
                  <label className="form-label mb-1 fw-semibold">
                    Select Client
                  </label>
                  <select
                    className="default-select wide form-select"
                    aria-label="Default select example"
                    id="select"
                    onChange={(e) => setClientStatus(e.target.value)}
                    value={ClientStatus}
                  >
                    <option value="null">All Client</option>
                    <option value="2">Live</option>
                    <option value="1">Demo</option>
                    <option value="0">2 Days Only</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-2 col-6">
                <div className="mb-3">
                  <label className="form-label mb-1 fw-semibold">
                    Trading Status
                  </label>
                  <select
                    className="default-select wide form-select"
                    aria-label="Default select example"
                    id="select"
                    onChange={(e) => setPanelStatus(e.target.value)}
                    value={PanelStatus}
                  >
                    <option value="2">All</option>
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>

              <div className="col-lg-2 col-6">
                <div className="mb-3">
                  <label className="form-label mb-1 fw-semibold">
                    Select Broker
                  </label>
                  <select
                    className="default-select wide form-select"
                    aria-label="Default select example"
                    id="select"
                    onChange={(e) => setSelectBroker(e.target.value)}
                    value={selectBroker}
                  >
                    <option value="null">All</option>

                    {brokers.map((broker) => (
                      <option key={broker.id} value={broker.id}>
                        {broker.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-3 col-6">
                <div className="mb-3 d-flex align-items-end">

                  <div className="flex-grow-1 me-2">
                    <label className="form-label mb-1 fw-semibold">
                      Select Strategy
                    </label>
                    <select
                      className="default-select wide form-select"
                      aria-label="Select Strategy"
                      id="select-strategy"
                      onChange={(e) => setStrategyClientStatus(e.target.value)}
                      value={StrategyClientStatus}
                    >
                      <option value="all">All</option>
                      {getAllStrategyNameData?.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.strategy_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <button
                      className="btn btn-sm btn-primary mt-auto"
                      onClick={() => {
                        setClientStatus("null");
                        setPanelStatus("2");
                        setSelectBroker("null");
                        setStrategyClientStatus("all");
                        setSearchInput("");
                        setSearchQuery("");
                        setPage(1);
                        setSizePerPage(10);
                        setLimit(10);
                        setCurrentPage(1);
                        setrefresh((prev) => !prev);

                        setIsSpinning(true);
                        setTimeout(() => setIsSpinning(false), 1000);
                      }}
                      title="Reset Filters"
                    >
                      <i
                        className={`fa fa-refresh ${isSpinning ? "fa-spin" : ""
                          }`}
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row"></div>
          </div>
          <div className="position-relative">
            {getAllClients?.loading || isSpinning ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "300px" }}
              >
                <Loader />
              </div>
            ) : (
              <Table
                columns={columns}
                data={getAllClients.data || []}
                totalRows={totalRows}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handlePerRowsChange}
                limit={limit}
              />
            )}
          </div>

          {/* <ToastButton /> */}
        </Content>

        {/* Backtest Permission Modal */}
        <Modal
          show={showPermissionModal}
          onHide={() => setShowPermissionModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>
              <Shield className="me-2" size={20} />
              Backtest Permission Management
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedUser && (
              <div>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">
                      Backtest Permission
                    </Form.Label>
                    <Form.Select
                      value={selectedUser.backtestPermission}
                      onChange={(e) =>
                        setSelectedUser({
                          ...selectedUser,
                          backtestPermission: e.target.value,
                        })
                      }
                    >
                      <option value="0">No</option>
                      <option value="1">
                        Has Permission (Can access backtesting)
                      </option>
                    </Form.Select>
                    <Form.Text className="text-muted">
                      This controls whether the user can access the backtesting
                      page at /client/backtesting
                    </Form.Text>
                  </Form.Group>
                </Form>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowPermissionModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleUpdatePermission}
              disabled={permissionLoading}
            >
              {permissionLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating...
                </>
              ) : (
                <>
                  <Settings className="me-2" size={16} />
                  Update Permission
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default AllClients;
